import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmallOrderLinksComponent } from './small-order-links.component';

const routes: Routes = [
  {
    path: '',
    component: SmallOrderLinksComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmallOrderLinksRoutingModule { }
